// extracted by mini-css-extract-plugin
export default {"horizontalGroup":"HorizontalGroup_horizontalGroup__DtsWk"};